import React from 'react';
import cn from 'classnames';
import {createUseStyles} from 'react-jss';
import IconBulb from '../components/icon/IconBulb';
import IconError from '../components/icon/IconError';
import IconInfo from '../components/icon/IconInfo';
import IconCheck from "../components/icon/IconCheck";

export enum TipType {
  Advice, Warning, Error, Info, Success
}

/**
 * @param id {number} Unique id
 * @param className {string} List of classes
 */
interface TipProps {
  className?: string,
  type?: TipType
}

/**
 * Tip/advice for a user
 */
export default function Tip({
                              className, type = TipType.Advice, children,
                            }: React.PropsWithChildren<TipProps>) {
  const styles = createUseStyles({
    info: {
      backgroundColor: '#DFF5FF',
    },
    success: {
      backgroundColor: '#E4F7C8',
    },

  })();
  let [infoStyles, successStyles] = ['', ''];
  if (type === TipType.Info) {
    infoStyles = styles.info;
  }
  if (type === TipType.Success) {
    successStyles = styles.success;
  }

  return (
    <div className={cn(
      'p-2 rounded-md flex align-top text-gray-dark italic', className,
      {'bg-yellow-light': type === TipType.Advice}, {'bg-red-light': type === TipType.Error},
      {'pr-3': type !== TipType.Warning}, infoStyles, successStyles
    )}>
      {type === TipType.Info &&
        <IconInfo className="text-blue pr-3 flex-shrink-0 text" height="2rem" title="Info"/>
      }
      {type === TipType.Advice &&
        <IconBulb className="text-yellow pr-3 flex-shrink-0 text" height="2rem" title="Tip"/>
      }
      {type === TipType.Error &&
        <IconError className="text-red pr-3 flex-shrink-0 text mt-1 block" height="1.5rem" title="Tip"/>
      }
      {type === TipType.Success &&
        <IconCheck className="text-green font-bold pr-3 flex-shrink-0 text mt-2" height="1rem" title="Tip"/>
      }
      <div className="pt-1 pb-2">
        {children}
      </div>
    </div>
  );
}
